import { convertJsonToOptionList } from '@lsfe/tools';

export const status = [
    { value: 0, label: '待确认' },
    { value: 1, label: '待收货' },
    { value: 2, label: '完成收货' },
    { value: 3, label: '生成中' },
    { value: 4, label: '超时关闭' },
    { value: 5, label: '生成失败' },
    { value: 7, label: '部分收货' },
    { value: 8, label: '已取消' },
    { value: 9, label: '取消中' },
    { value: 10, label: '取消失败' },
    { value: 11, label: '待审核' },
];

export const statusMap = status.reduce((pre, cur) => {
    pre[cur.value] = cur.label;
    return pre;
}, {});

export const skuPriceType = {
    0: '常规',
    1: '赠品',
    2: '预订单',
};

export const storageTemperatureLevel = {
    1: '冷冻',
    2: '冷藏',
    5: '常温',
    7: '热食',
};

// 销售对账单生成周期
export const saleSettlementGeneratePeriod = {
    1: '按日',
    2: '按自然月',
};

export const jointType = {
    1: '餐饮联营',
    2: '标品联营',
};

export const RefundStatus = [
    { value: 10, label: '待确认' },
    { value: 3, label: '待提货' },
    { value: 15, label: '分拣完成' },
    { value: 12, label: '提货中' },
    { value: 7, label: '已完成' },
    { value: 2, label: '生成失败' },
    { value: 6, label: '已关闭' },
    { value: 5, label: '关闭失败' },
    { value: 14, label: '退货价变更中' },
];

export const RefundStatusMap = {
    0: '草稿',
    1: '生成中',
    2: '生成失败',
    3: '待提货',
    4: '关闭中',
    5: '关闭失败',
    6: '已关闭',
    7: '已完成',
    8: '已删除',
    9: '待审核',
    10: '待确认',
    11: '待下发',
    12: '出库完成',
    14: '退货价变更中',
    15: '分拣完成',
};
// 劳务历史数据及劳务发薪拆分业务类型
export const businessMap = {
    /** 劳务历史数据 */
    HISTORY_DATA_SOURCE: 10,
    /** 服务站劳务 */
    SERVICE_STATION_LABOUR: 20,
    /** 大仓劳务 */
    WAREHOUSE_LABOUR: 21,
    /** H大店劳务 */
    H_LABOUR: 22,
    /** 服务站中台 */
    SERVICE_STATION_MIDDLE_OFFICE: 23,
    /** 仓中台 */
    WAREHOUSE_MIDDLE_OFFICE: 24,
    /** CDC */
    CDC: 25,
};

// 退货单状态
export const RefundStatusAll = convertJsonToOptionList(RefundStatusMap);
